<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import Switch from "./Switch.vue";
import { cn } from "@/lib/utils";

interface Props {
  modelValue?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  value?: string;
  id?: string;
  label?: string;
  labelPosition?: "left" | "right";
  class?: HTMLAttributes["class"];
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  labelPosition: "right",
  modelValue: undefined,
});

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
}>();
</script>

<template>
  <div
    :class="
      cn(
        'inline-flex items-center gap-2',
        labelPosition === 'left' ? 'flex-row-reverse' : 'flex-row',
        disabled && 'opacity-50 cursor-not-allowed',
      )
    "
  >
    <Switch
      :id="id"
      :modelValue="modelValue"
      :defaultValue="defaultChecked"
      :disabled="disabled"
      :required="required"
      :name="name"
      :value="value"
      :class="$props.class"
      :aria-label="ariaLabel || label"
      @update:model-value="(value) => emit('update:modelValue', value)"
    />
    <label
      v-if="label"
      :for="id"
      :class="
        cn(
          'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          disabled && 'cursor-not-allowed opacity-70',
        )
      "
    >
      {{ label }}
    </label>
  </div>
</template>
